import { install } from "capsid";
import debug from "capsid/debug";
install(debug);
import "./splash-screen";
import "./main-screen";
import "./toast";
import "./dialogs/list-dialog";
import "./dialogs/edit-dialog";
import "./dialogs/confirm-dialog";
import "./dialogs/manual-dialog";
